module.exports = __webpack_public_path__ + "images/148874ab596d937cc6447b161eb04528.svg";